import type { ArithmeticOperation } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface OperationSelectProps
  extends Omit<SelectProps<ArithmeticOperation>, "options"> {}

const OperationSelect: React.FC<OperationSelectProps> = ({ ...props }) => {
  const translations = useTranslate({
    addition: "operations.addition",
    subtraction: "operations.subtraction",
    multiplication: "operations.multiplication",
    division: "operations.division",
  })

  const options: SelectOption<ArithmeticOperation>[] = [
    { value: "addition", label: translations.addition },
    { value: "subtraction", label: translations.subtraction },
    { value: "multiplication", label: translations.multiplication },
    { value: "division", label: translations.division },
  ]

  return <Select {...props} options={options} />
}

export default OperationSelect
